<template>
  <mobile-responsive-shell :title="title">
    <div class="credit-mobile">
      <p v-if="!credits || credits.length === 0" class="credit-mobile-empty text-muted">
        Aucun solde.
      </p>

      <div v-else class="credit-mobile-list">
        <article
          v-for="(credit, idx) in credits"
          :key="credit.customer_reference || idx"
          class="credit-mobile-card"
        >
          <div class="credit-mobile-card-head">
            <span class="credit-mobile-ref">{{ credit.customer_reference }}</span>
          </div>
          <p class="credit-mobile-name">
            {{ credit.customer ? credit.customer.fullName : "—" }}
          </p>
          <div class="credit-mobile-amounts">
            <div>
              <span class="credit-mobile-label">Total</span>
              <span class="fw-semibold">{{ formatNum(credit.total) }}</span>
            </div>
            <div>
              <span class="credit-mobile-label">Total TTC</span>
              <span class="fw-semibold">{{ formatNum(credit.totalTTC) }}</span>
            </div>
          </div>
          <footer class="credit-mobile-dates">
            <span>Du {{ credit.firstDate || "—" }}</span>
            <span>Au {{ credit.lastDate || "—" }}</span>
          </footer>
        </article>
      </div>
    </div>
  </mobile-responsive-shell>
</template>

<script>
import { mapGetters } from "vuex";
import MobileResponsiveShell from "../../components/MobileResponsiveShell.vue";

export default {
  name: "MobileCreditsSuppliersBalance",
  components: { MobileResponsiveShell },
  data() {
    return {
      title: "Soldes (fournisseurs)",
    };
  },
  computed: {
    ...mapGetters("credit", {
      credits: "getAll",
    }),
  },
  mounted() {
    this.$store.dispatch("credit/getCreditBalance");
  },
  methods: {
    formatNum(v) {
      const n = parseFloat(v);
      if (Number.isNaN(n)) return "—";
      return n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
  },
};
</script>

<style scoped>
.credit-mobile-empty {
  text-align: center;
  padding: 2rem 1rem;
}
.credit-mobile-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.credit-mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 0.875rem 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.credit-mobile-card-head {
  margin-bottom: 0.5rem;
}
.credit-mobile-ref {
  font-weight: 700;
  font-size: 0.9rem;
}
.credit-mobile-name {
  margin: 0 0 0.5rem;
  font-size: 0.95rem;
}
.credit-mobile-amounts {
  display: flex;
  gap: 1.25rem;
  margin-bottom: 0.5rem;
}
.credit-mobile-label {
  display: block;
  font-size: 0.7rem;
  text-transform: uppercase;
  color: #6c757d;
}
.credit-mobile-dates {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  padding-top: 0.5rem;
  border-top: 1px solid #eee;
  font-size: 0.8rem;
  color: #495057;
}
</style>
